export default __webpack_public_path__ + "static/media/flop-types_0004_thumb.31e176af.jpg";